export function GoogleIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7031_4088)">
        <path
          opacity="0.1"
          d="M0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12Z"
          fill="#698199"
        />
        <path
          d="M12.26 11.2079V13.712H16.3614C16.1807 14.7649 15.1279 16.8344 12.26 16.8344C9.79129 16.8344 7.75864 14.801 7.75864 12.26C7.75864 9.719 9.79129 7.68714 12.26 7.68714C13.6759 7.68714 14.6195 8.30393 15.164 8.8115L17.1244 6.92421C15.8539 5.726 14.2204 5 12.26 5C8.23086 5 5 8.267 5 12.26C5 16.253 8.23086 19.52 12.26 19.52C16.4345 19.52 19.2293 16.5799 19.2293 12.4054C19.2293 11.9339 19.1931 11.5709 19.1209 11.2079H12.26Z"
          fill="#2CA94F"
        />
        <path
          d="M17.2336 17.6328C18.5033 16.3623 19.2293 14.5473 19.2293 12.4416C19.2293 11.9701 19.1932 11.6071 19.1209 11.2441H12.26V13.7121H16.3614C16.253 14.3296 15.8539 15.3094 14.9825 15.9993L17.2328 17.6328H17.2336Z"
          fill="#3E82F7"
        />
        <path
          d="M5.87136 15.7085C5.29915 14.6491 4.99969 13.464 5 12.26C5 11.171 5.21764 10.1543 5.65371 9.24756L7.97629 10.8811C7.83062 11.3261 7.75715 11.7917 7.75864 12.26C7.75864 12.8776 7.86786 13.4943 8.12164 14.0388L5.87214 15.7085H5.87136Z"
          fill="#FCBD00"
        />
        <path
          d="M5.65369 9.24759C6.22903 7.97872 7.15847 6.90294 8.33036 6.14946C9.50225 5.39598 10.8668 4.99685 12.26 5.00002C14.2203 5.00002 15.8538 5.72602 17.1235 6.88809L15.164 8.77538C14.6195 8.26702 13.6758 7.65023 12.26 7.65023C10.2273 7.65023 8.48462 9.06609 7.94011 10.9895L5.65369 9.24759Z"
          fill="#ED422C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7031_4088">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
